import { Component } from "react";
import { reportClientError } from "../../api/alerts";

// For optional sections (the pay page's extras, reviews, FAQ): if one fails to
// render, it quietly disappears and reports itself, and everything around it
// (the quote and its pay buttons) keeps working. The page-wide ErrorBoundary
// would replace the whole page instead.
export default class SilentBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    reportClientError({
      where: this.props.where || "optional section",
      message: error?.message || String(error),
      token: this.props.token,
    });
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
